var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{attrs:{"help":"HelpProducts"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Products and Services Offered")])])
}
var staticRenderFns = []

export { render, staticRenderFns }